import { E } from '@angular/cdk/keycodes';
import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { format, parse } from 'date-fns';
import { Subscription } from 'rxjs';
import { TaskListEnum } from 'src/app/enums/taskList';
import { ApiService } from 'src/app/services/api.service';
@Component({
  selector: 'app-status-list',
  templateUrl: './status-list.component.html',
  styleUrls: ['./status-list.component.scss'],
})
export class StatusListComponent implements OnInit {
  @Input() data: any;
  @Input() assetTypeId: any;
  @Input() assetId: any;
  formTitle: string;
  statusListForm: FormGroup;
  maxDate: Date = new Date();
  isSaving: boolean = false;
  taskIdList:any=[]
  public statusListSub: Subscription;
  public awdbSub: Subscription;
  taskListEnums=TaskListEnum
  status:any=['OPEN','C/W - REPETITIVE', 'C/W - TERMINATED', 'SUPERSEDED', 'ACCOMPLISHED IN PRODUCTION', 'NOT APPLICABLE']
  filteredItems:any[]
  maintenanceTypeList:any=[]
  selectedMaintenanceTypeList:any
  repairCategoryDropDownOptions=[{name:'PERMANENT'},{name:'PERMANENT WITH ADDITIONAL REQUIREMENT'},{name:'TEMPORARY'}]
  additionalRequirementDropDownOptions=[{name:'PERMANENT REPAIR'},{name:'INSPECTION'},{name:'DTA'},{name:'FURTHER APPROVAL'},{name:'OTHER'}]
  // maintenanceTypeList:any=[{name:' Air Worthiness Directive',value:1},{name:'MPD',value:5}]
  editableForm:boolean=false
  summaryApiGetCallResponse: boolean = false;
  formDisableEnableUsingRepairDamageValue:boolean=false
  repairDamageFieldsShowHide:boolean = false // this will use to show form fields only for repair damage
  occureArray: Object[];
  airCraftData:any
  headerName:string = ''
  taskIdLoadingDataLength:boolean= false
  repairDamageDropDownArray = ['repair','damage']
  repairClassification = ['minor','major']
  constructor( private route: ActivatedRoute,private modalController: ModalController,private snackBar: MatSnackBar,public apiService: ApiService,private cdr : ChangeDetectorRef) {
  this.getDataMaintenanceId()
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.airCraftData = params; // Save query parameters
      this.headerName = this.airCraftData?.task === 'repairDamage' ? this.taskListEnums.REPAIRDAMAGE : ''

    });
    this.occureArray = [
      { value: "First", label: "First" },
      { value: "Last", label: "Last" },
    ];
    // if(this.headerName !== this.taskListEnums.REPAIRDAMAGE || this.data?.maintenanceTypeName !== this.taskListEnums.REPAIRDAMAGE){
    //   this.statusListForm = new FormGroup({
    //     assetTypeId: new FormControl(''),
    //     assetId: new FormControl(''),
    //     maintenanceTypeId: new FormControl('', [Validators.required]),
    //     statusListId: new FormControl('',[Validators.required]),
    //     thresholdTat: new FormControl(''),
    //     thresholdTac: new FormControl(''),
    //     repeatIntervalDays: new FormControl(''),
    //     repeatIntervalFh: new FormControl(''),
    //     repeatIntervalFc: new FormControl(''),
    //     thresholdDate: new FormControl(''),
    //     occurrenceAlertRepeatInterval: new FormControl(''),
    //     occurrenceAlertThreshold: new FormControl(''),
    //     repairCategory: new FormControl(null),
    //     additionalRequirement: new FormControl(null),
    //     status: new FormControl('', [Validators.required]),
    //       });
    // }
    // else{
      if(this.data){
        this.headerName = this.airCraftData?.task === 'repairDamage' ? this.taskListEnums.REPAIRDAMAGE : ''
      }
      this.statusListForm = new FormGroup({
        mappingNumber: new FormControl(null),
        repairNumber: new FormControl(null),
        repairDamage: new FormControl(null,[Validators.required]),
        eoEaTi: new FormControl(null),
        description: new FormControl(null),
        repairClassification: new FormControl(null,[Validators.required]),
        ataChapter: new FormControl(null),
        approvedDataSrmReference: new FormControl(null),
        approvedDataSrmRevisionNumber: new FormControl(null),

        //new 4 fields added for repairDamage and SBMod
        woNrcDfpRef: new FormControl(null),
        performedDate: new FormControl(null),
        performedTac: new FormControl(null),
        performedTat: new FormControl(null),
        initialComplianceRemarks: new FormControl(null),

        // assetTypeId: new FormControl(''),
        maintenanceTypeId: new FormControl(''),
        assetId: new FormControl(''),
        thresholdTat: new FormControl(''),
        thresholdTac: new FormControl(''),
        repeatIntervalDays: new FormControl(''),
        repeatIntervalFh: new FormControl(''),
        repeatIntervalFc: new FormControl(''),
        thresholdDate: new FormControl(''),
        occurrenceAlertRepeatInterval: new FormControl(''),
        occurrenceAlertThreshold: new FormControl(''),
        repairCategory: new FormControl(null),
        additionalRequirement: new FormControl(null),
          });
    // }

    this.formTitle = 'Add ' + this.headerName;

        if (this.data !== null){
          this.summaryApiGetCallResponse = true
          this.setForm();
          // this.getData()
        }

  }

  public getDataMaintenanceId(): void {

    try {
    this.awdbSub = this.apiService.getMaintenanceId().subscribe((res: any[]) => {
        if (res?.length !== undefined) {
          res.map(e=>{
            if(!this.data){
              if(this.headerName == e.name){
                this.maintenanceTypeList.push({name:e.name,value:e.id})
                this.statusListForm.controls.maintenanceTypeId.setValue(e.id)
                this.maintenanceTaskChangebyMaintenanceType({name:e.name,value:e.id})
              }
            }
            else{
              this.maintenanceTypeList.push({name:e.name,value:e.id})
            }
          })
          // if(this.data){
          //   if (this.data?.maintenanceTypeName !== this.taskListEnums.REPAIRDAMAGE) {
          //     this.repairDamageFieldsShowHide = true; //hide form fields if the value changed
          //     this.apiService.maintenanceTaskAddEditModelHeightChangeUsingRepairCategory.next(true);
          //   } else {
          //     this.repairDamageFieldsShowHide = false;
          //     this.apiService.maintenanceTaskAddEditModelHeightChangeUsingRepairCategory.next(false);
          //   }
          // }
          if(this.data){
            this.taskIdList = []
            this.selectedMaintenanceTypeList=this.maintenanceTypeList.find(e=> e.value == this.data?.maintenanceTypeId)
           if(this.data?.maintenanceTypeName ===   this.taskListEnums.REPAIRDAMAGE){
              this.clearValidationOnForm()
              this.apiService.maintenanceTaskAddEditModelHeightChangeUsingRepairCategory.next(true)
              this.repairDamageFieldsShowHide = true
              // this.getRepairDemageData()
            }
          }
          // this.maintenanceId = res.find(e=> e.name === 'REPAIR DAMAGE');
        }
      },(err:any)=>{
        this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)

      }),(err:any)=>{
        this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
      };
      } catch (err) {
        this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
      }
  }


      maintenanceTaskChangebyMaintenanceType(event:any){
      //all check for repair damage form and validation is null in start until maintenance type is repair damage
      this.selectedMaintenanceTypeList=this.maintenanceTypeList.find(e=> e.value == event.value)
      this.repairDamageFieldsShowHide = false
      this.formDisableEnableUsingRepairDamageValue = false
      this.statusListForm.get('repairCategory').setValue(null)
      this.statusListForm.get('additionalRequirement').setValue(null)
      this.statusListForm.get('additionalRequirement').enable({ emitEvent: false })
      this.apiService.maintenanceTaskAddEditModelHeightChangeUsingRepairCategory.next(false);
      // on maintenance task type value change  task id must be null in start until user select from dropdown
      if(event?.value === this.maintenanceTypeList.find(e=> e.name !== this.taskListEnums.REPAIRDAMAGE)?.value){
        this.statusListForm.get('statusListId')?.setValue(null)
      }
      if(event?.value === this.maintenanceTypeList.find(e=> e.name === this.taskListEnums.REPAIRDAMAGE)?.value){
        this.clearValidationOnForm()
        this.apiService.maintenanceTaskAddEditModelHeightChangeUsingRepairCategory.next(true)
        this.repairDamageFieldsShowHide = true
        // this.getRepairDemageData()
      }
    }
  toggleEditableForm(): void {
    this.editableForm = true;
  }
  isDisabled(): boolean {
    return this.data ? this.editableForm : false;
  }
  updateDisabledState(): void {
    if (this.editableForm) {
        this.statusListForm.get('maintenanceTypeId')?.disable({ emitEvent: false });

        this.statusListForm.get('repairCategory')?.disable({ emitEvent: false });
        this.statusListForm.get('additionalRequirement')?.disable({ emitEvent: false });
        this.statusListForm.get('occurrenceAlertRepeatInterval')?.disable({ emitEvent: false });
        this.statusListForm.get('occurrenceAlertThreshold')?.disable({ emitEvent: false });
    } else {
        this.statusListForm.get('maintenanceTypeId')?.enable({ emitEvent: false });

        this.statusListForm.get('repairCategory')?.enable({ emitEvent: false });
        this.statusListForm.get('occurrenceAlertRepeatInterval')?.enable({ emitEvent: false });
        this.statusListForm.get('occurrenceAlertThreshold')?.enable({ emitEvent: false });
        this.data?.repairCategory?.toLowerCase() === 'permanent'  ? this.statusListForm.get('additionalRequirement').disable({ emitEvent: false }) : this.statusListForm.get('additionalRequirement').enable({ emitEvent: false });
        this.data?.repairCategory?.toLowerCase() === 'permanent'  ? this.statusListForm.get('occurrenceAlertRepeatInterval').disable({ emitEvent: false }) : this.statusListForm.get('occurrenceAlertRepeatInterval').enable({ emitEvent: false });
        this.data?.repairCategory?.toLowerCase() === 'permanent'  ? this.statusListForm.get('occurrenceAlertThreshold').disable({ emitEvent: false }) : this.statusListForm.get('occurrenceAlertThreshold').enable({ emitEvent: false });
    }
    if(this.headerName !== this.taskListEnums.REPAIRDAMAGE || this.data?.maintenanceTypeName !== this.taskListEnums.REPAIRDAMAGE){
      const shouldDisable = !!this.editableForm; // Convert to boolean
    this.toggleFormControls(this.statusListForm, shouldDisable, [
        'type','repairDamage','repairClassification'
    ]);

    // Optional: Trigger Angular's change detection
    this.cdr.detectChanges();
    }
    this.data?.repairCategory?.toLowerCase() === 'permanent'  ? this.formDisableEnableUsingRepairDamageValue = true : this.formDisableEnableUsingRepairDamageValue = false;

    // Optional: Trigger Angular's change detection
    this.cdr.detectChanges();
}

private toggleFormControls(formGroup: FormGroup, disable: boolean, controlNames: string[]): void {
  controlNames.forEach(controlName => {
      const control = formGroup.get(controlName);
      if (control) {
          disable ? control.disable({ emitEvent: false }) : control.enable({ emitEvent: false });
      }
  });
}

  public setForm(): void{
      if (this.data?.id > 0){
        this.formTitle = this.data ? 'Edit ' + ' ' + this.headerName || this.data?.maintenanceTypeName : 'Add ' + ' ' + this.headerName || this.data?.maintenanceTypeName;


          this.statusListForm = new FormGroup({

            mappingNumber: new FormControl(this.data?.mappingNumber),
            repairNumber: new FormControl(this.data?.repairNumber),
            repairDamage: new FormControl(this.data?.repairDamage,[Validators.required]),
            eoEaTi: new FormControl(this.data?.eoEaTi),
            description: new FormControl(this.data?.description),
            repairClassification: new FormControl(this.data?.repairClassification,[Validators.required]),
            ataChapter: new FormControl(this.data?.ataChapter),
            approvedDataSrmReference: new FormControl(this.data?.approvedDataSrmReference),
            approvedDataSrmRevisionNumber: new FormControl(this.data?.approvedDataSrmRevisionNumber),

             //new 4 fields added for repairDamage and SBMod
            woNrcDfpRef: new FormControl(this.data?.woNrcDfpRef),
            performedDate: new FormControl(this.data?.performedDate && this.data?.performedDate?.toString() !== '0000-00-00' ? parse(this.data?.performedDate, 'yyyy-MM-dd', new Date()) : null),
            performedTac: new FormControl(this.data?.performedTac),
            performedTat: new FormControl(this.data?.performedTat),
            initialComplianceRemarks: new FormControl(this.data?.initialComplianceRemarks),

            // assetTypeId: new FormControl(this.data?.assetTypeId,),
            maintenanceTypeId: new FormControl(this.data?.maintenanceTypeId),
            assetId: new FormControl(this.data?.assetId),
            thresholdTat: new FormControl(this.data?.thresholdTat),
            thresholdTac: new FormControl(this.data?.thresholdTac),
            repeatIntervalDays: new FormControl(this.data?.repeatIntervalDays),
            repeatIntervalFh: new FormControl(this.data?.repeatIntervalFh),
            repeatIntervalFc: new FormControl(this.data?.repeatIntervalFc),
            thresholdDate: new FormControl(this.data?.thresholdDate && this.data?.thresholdDate?.toString() !== '0000-00-00' ? parse(this.data?.thresholdDate, 'yyyy-MM-dd', new Date()) : null),
            repairCategory: new FormControl(this.data?.repairCategory),
            additionalRequirement: new FormControl(this.data?.additionalRequirement),
            occurrenceAlertRepeatInterval: new FormControl(this.data?.occurrenceAlertRepeatInterval),
            occurrenceAlertThreshold: new FormControl(this.data?.occurrenceAlertThreshold),
            id: new FormControl(this.data?.id)
          });

        this.data?.repairCategory?.toLowerCase() === 'permanent'  ? this.formDisableEnableUsingRepairDamageValue = true : this.formDisableEnableUsingRepairDamageValue = false;
        this.data?.repairCategory?.toLowerCase() === 'permanent'  ? this.statusListForm.get('additionalRequirement').disable({ emitEvent: false }) : this.statusListForm.get('additionalRequirement').enable({ emitEvent: false });
        this.data?.repairCategory?.toLowerCase() === 'permanent'  ? this.statusListForm.get('occurrenceAlertRepeatInterval').disable({ emitEvent: false }) : this.statusListForm.get('occurrenceAlertRepeatInterval').enable({ emitEvent: false });
        this.data?.repairCategory?.toLowerCase() === 'permanent'  ? this.statusListForm.get('occurrenceAlertThreshold').disable({ emitEvent: false }) : this.statusListForm.get('occurrenceAlertThreshold').enable({ emitEvent: false });
      }
      this.updateDisabledState()
      this.summaryApiGetCallResponse = false
    }


  dismissModal() {
    this.selectedMaintenanceTypeList = null
     this.apiService.maintenanceTaskAddEditModelHeightChangeUsingRepairCategory.next(false);
    this.modalController.dismiss({
      'dismissed': false
    });
  }

  public submit(): void{
    //if the ad detail tasklist is not for repiar damage then api payload object

    // for repair damage
    this.statusListForm.get('repairDamage')?.setValidators([Validators.required])
    this.statusListForm.get('repairClassification')?.setValidators([Validators.required])
    this.statusListForm.get('repairDamage')?.updateValueAndValidity();
    this.statusListForm.get('repairClassification')?.updateValueAndValidity();

    if (this.statusListForm.invalid) {
      this.statusListForm.markAllAsTouched();
      return;
    }
    const repairNumberValue = this.statusListForm.get('repairNumber')?.value ? String(this.statusListForm.get('repairNumber')?.value).trim() : null;
    const repairDamageValue = this.statusListForm.get('mappingNumber')?.value ? String(this.statusListForm.get('mappingNumber')?.value).trim() : null;
    //if the ad detail Maintenance Status is repair damage then these fields will require
    if(this.headerName === this.taskListEnums.REPAIRDAMAGE || this.data?.maintenanceTypeName === this.taskListEnums.REPAIRDAMAGE){
      if (!repairNumberValue && !repairDamageValue) {
        this.statusListForm.get('repairNumber')?.setValidators([Validators.required]);
        this.statusListForm.get('mappingNumber')?.setValidators([Validators.required]);

        // Apply changes
        this.statusListForm.get('repairNumber')?.updateValueAndValidity();
        this.statusListForm.get('mappingNumber')?.updateValueAndValidity();

        this.cdr.detectChanges();
        this.statusListForm.markAllAsTouched();
        return;
      }
    }
    const repairCategoryValue = this.statusListForm.get('repairCategory')?.value ? this.statusListForm.get('repairCategory')?.value : null
    const maintenanceTypeIdValue = this.statusListForm.get('maintenanceTypeId')?.value ? this.statusListForm.get('maintenanceTypeId')?.value : null

 // Keep as null if empty
    //repair category required for repair damage and repair category value condition
    if((maintenanceTypeIdValue === this.maintenanceTypeList.find(e=> e.name === this.taskListEnums.REPAIRDAMAGE)?.value) && !repairCategoryValue){
      this.statusListForm.get('repairCategory')?.setValidators([Validators.required]);
      this.statusListForm.get('repairCategory')?.updateValueAndValidity();
      this.statusListForm.markAsUntouched()
      return
    }
    if(repairCategoryValue?.toUpperCase() === 'PERMANENT WITH ADDITIONAL REQUIREMENT'){
      if(this.applyRequiredFormCheck(true)){
        this.statusListForm.markAsUntouched()
        return
      }
    }
    this.isSaving = true;
    this.statusListApiCall();
  }

  applyRequiredFormCheck(formSubmitted?:boolean){
    const thresholdTatValue = this.statusListForm.get('thresholdTat')?.value ? String(this.statusListForm.get('thresholdTat')?.value).trim() : null;
    const thresholdTacValue = this.statusListForm.get('thresholdTac')?.value ? String(this.statusListForm.get('thresholdTac')?.value).trim() : null;
    const repeatIntervalDaysValue = this.statusListForm.get('repeatIntervalDays')?.value ? String(this.statusListForm.get('repeatIntervalDays')?.value).trim() : null;
    const repeatIntervalFhValue = this.statusListForm.get('repeatIntervalFh')?.value ? String(this.statusListForm.get('repeatIntervalFh')?.value).trim() : null;
    const repeatIntervalFcValue = this.statusListForm.get('repeatIntervalFc')?.value ? String(this.statusListForm.get('repeatIntervalFc')?.value).trim() : null;
    const occurrenceAlertRepeatIntervalValue = this.statusListForm.get('occurrenceAlertRepeatInterval')?.value ? String(this.statusListForm.get('occurrenceAlertRepeatInterval')?.value).trim() : null;
    const occurrenceAlertThresholdValue = this.statusListForm.get('occurrenceAlertThreshold')?.value ? String(this.statusListForm.get('occurrenceAlertThreshold')?.value).trim() : null;
    const thresholdDate = this.statusListForm.get('thresholdDate')?.value;

    const formatted = thresholdDate
    ? format(thresholdDate, 'yyyy-MM-dd')
    : null;

    const thresholdDateValue = formatted === '0000-00-00' ? null : formatted;
  //   const thresholdDateValue = this.statusListForm.get('thresholdDate')?.value
  // ? this.statusListForm.get('thresholdDate')?.value?.toString() !== '0000-00-00' ? parse(this.statusListForm.get('thresholdDate')?.value, 'yyyy-MM-dd', new Date()) : null
  // : null;
  const repairCategoryValue = this.statusListForm.get('repairCategory')?.value ? this.statusListForm.get('repairCategory')?.value : null
    // Keep as null if empty

    // If both fields are empty, apply required validation
    if (!thresholdTatValue && !thresholdTacValue && !repeatIntervalDaysValue && !repeatIntervalFhValue && !repeatIntervalFcValue && !thresholdDateValue && (repairCategoryValue?.toLowerCase() !== 'permanent'  || !repairCategoryValue || !occurrenceAlertRepeatIntervalValue || !occurrenceAlertThresholdValue)) {

      this.statusListForm.get('thresholdTat')?.setValidators([Validators.required]);
      this.statusListForm.get('thresholdTac')?.setValidators([Validators.required]);
      this.statusListForm.get('repeatIntervalDays')?.setValidators([Validators.required]);
      this.statusListForm.get('repeatIntervalFh')?.setValidators([Validators.required]);
      this.statusListForm.get('repeatIntervalFc')?.setValidators([Validators.required]);
      this.statusListForm.get('thresholdDate')?.setValidators([Validators.required]);
      this.statusListForm.get('occurrenceAlertRepeatInterval')?.setValidators([Validators.required]);
      this.statusListForm.get('occurrenceAlertThreshold')?.setValidators([Validators.required]);

      // Apply changes
      this.statusListForm.get('thresholdTat')?.updateValueAndValidity();
      this.statusListForm.get('thresholdTac')?.updateValueAndValidity();
      this.statusListForm.get('repeatIntervalDays')?.updateValueAndValidity();
      this.statusListForm.get('repeatIntervalFh')?.updateValueAndValidity();
      this.statusListForm.get('repeatIntervalFc')?.updateValueAndValidity();
      this.statusListForm.get('thresholdDate')?.updateValueAndValidity();
      this.statusListForm.get('occurrenceAlertThreshold')?.updateValueAndValidity();
      this.statusListForm.get('occurrenceAlertRepeatInterval')?.updateValueAndValidity();
      if(repairCategoryValue?.toUpperCase() === 'PERMANENT WITH ADDITIONAL REQUIREMENT' || repairCategoryValue?.toUpperCase() === 'TEMPORARY'){
        this.statusListForm.get('additionalRequirement')?.setValidators([Validators.required]);
        this.statusListForm.get('additionalRequirement')?.updateValueAndValidity();
      }
      else{
        this.statusListForm.get('additionalRequirement')?.clearValidators();
        this.statusListForm.get('additionalRequirement')?.setErrors(null);
      }
      this.cdr.detectChanges();
      if(formSubmitted === true){
        this.statusListForm.markAllAsTouched();
      }
      return true;
    }
    return false;

  }



  clearValidationOnForm(){
    const thresholdTatValue = this.statusListForm.get('thresholdTat')?.value ? (this.statusListForm.get('thresholdTat')?.value.toString())?.trim() : null;
    const thresholdTacValue = this.statusListForm.get('thresholdTac')?.value ? (this.statusListForm.get('thresholdTac')?.value.toString())?.trim() : null;
    const repeatIntervalDaysValue =  this.statusListForm.get('repeatIntervalDays')?.value ? (this.statusListForm.get('repeatIntervalDays')?.value.toString())?.trim() : null;
    const repeatIntervalFhValue = this.statusListForm.get('repeatIntervalFh')?.value ? (this.statusListForm.get('repeatIntervalFh')?.value.toString())?.trim() : null;
    const repeatIntervalFcValue = this.statusListForm.get('repeatIntervalFc')?.value ? (this.statusListForm.get('repeatIntervalFc')?.value.toString())?.trim() : null;
    const occurrenceAlertRepeatIntervalValue = this.statusListForm.get('occurrenceAlertRepeatInterval')?.value ? (this.statusListForm.get('occurrenceAlertRepeatInterval')?.value.toString())?.trim() : null;
    const occurrenceAlertThresholdValue = this.statusListForm.get('occurrenceAlertThreshold')?.value ? (this.statusListForm.get('occurrenceAlertThreshold')?.value.toString())?.trim() : null;
    const thresholdDateValue = this.statusListForm.get('thresholdDate')?.value;
    const repairCategoryValue = this.statusListForm.get('repairCategory')?.value
    const maintenanceTypeIdValue = this.statusListForm.get('maintenanceTypeId')?.value ? this.statusListForm.get('maintenanceTypeId')?.value : null

    if (occurrenceAlertRepeatIntervalValue || occurrenceAlertThresholdValue || thresholdTatValue || thresholdTacValue || repeatIntervalDaysValue || repeatIntervalFhValue || repeatIntervalFcValue || thresholdDateValue || (repairCategoryValue?.toUpperCase() !== 'PERMANENT WITH ADDITIONAL REQUIREMENT' && repairCategoryValue?.toUpperCase() !== 'TEMPORARY') || ((maintenanceTypeIdValue === this.maintenanceTypeList.find(e=> e.name === this.taskListEnums.REPAIRDAMAGE )?.value) && !repairCategoryValue)) {

      this.statusListForm.get('thresholdTat')?.clearValidators();
      this.statusListForm.get('thresholdTat')?.setErrors(null);

      this.statusListForm.get('thresholdTac')?.clearValidators();
      this.statusListForm.get('thresholdTac')?.setErrors(null);

      this.statusListForm.get('repeatIntervalDays')?.clearValidators();
      this.statusListForm.get('repeatIntervalDays')?.setErrors(null);

      this.statusListForm.get('repeatIntervalFh')?.clearValidators();
      this.statusListForm.get('repeatIntervalFh')?.setErrors(null);

      this.statusListForm.get('repeatIntervalFc')?.clearValidators();
      this.statusListForm.get('repeatIntervalFc')?.setErrors(null);

      this.statusListForm.get('thresholdDate')?.clearValidators();
      this.statusListForm.get('thresholdDate')?.setErrors(null);

      this.statusListForm.get('occurrenceAlertRepeatInterval')?.clearValidators();
      this.statusListForm.get('occurrenceAlertRepeatInterval')?.setErrors(null);

      this.statusListForm.get('occurrenceAlertThreshold')?.clearValidators();
      this.statusListForm.get('occurrenceAlertThreshold')?.setErrors(null);

      this.statusListForm.get('additionalRequirement')?.clearValidators();
      this.statusListForm.get('additionalRequirement')?.setErrors(null);
      if((this.headerName === this.taskListEnums.REPAIRDAMAGE) && !repairCategoryValue){
        this.statusListForm.get('repairCategory')?.clearValidators();
          this.statusListForm.get('repairCategory')?.setErrors(null);
      }
    }

    // Apply changes
    this.statusListForm.get('thresholdTat')?.updateValueAndValidity();
    this.statusListForm.get('thresholdTac')?.updateValueAndValidity();
    this.statusListForm.get('repeatIntervalDays')?.updateValueAndValidity();
    this.statusListForm.get('repeatIntervalFh')?.updateValueAndValidity();
    this.statusListForm.get('repeatIntervalFc')?.updateValueAndValidity();
    this.statusListForm.get('thresholdDate')?.updateValueAndValidity();
    this.statusListForm.get('additionalRequirement')?.updateValueAndValidity();
    this.statusListForm.get('repairCategory')?.updateValueAndValidity();
    this.statusListForm.get('occurrenceAlertRepeatInterval')?.updateValueAndValidity();
    this.statusListForm.get('occurrenceAlertThreshold')?.updateValueAndValidity();

    this.cdr.detectChanges();
  }

  public statusListApiCall(): void{
      try{
        var obj: any;
        obj = {
          assetId: Number(this.assetId),
          thresholdTat: this.statusListForm.value.thresholdTat ? this.statusListForm.value.thresholdTat : null,
          thresholdTac: this.statusListForm.value.thresholdTac ? this.statusListForm.value.thresholdTac : null,
          repeatIntervalDays: this.statusListForm.value.repeatIntervalDays ? this.statusListForm.value.repeatIntervalDays : null,
          repeatIntervalFh: this.statusListForm.value.repeatIntervalFh ? this.statusListForm.value.repeatIntervalFh : null,
          repeatIntervalFc: this.statusListForm.value.repeatIntervalFc ? this.statusListForm.value.repeatIntervalFc : null,
          thresholdDate: this.statusListForm.value.thresholdDate ? format( new Date(this.statusListForm.value.thresholdDate), "yyyy-MM-dd") : null,
          occurrenceAlertThreshold:this.statusListForm.value.occurrenceAlertThreshold ? this.statusListForm.value.occurrenceAlertThreshold : null,
          occurrenceAlertRepeatInterval:this.statusListForm.value.occurrenceAlertRepeatInterval ? this.statusListForm.value.occurrenceAlertRepeatInterval : null,
          assetTypeId:Number(this.assetTypeId),
          additionalRequirement:this.statusListForm.value.additionalRequirement ? this.statusListForm.value.additionalRequirement : null,
          repairCategory:this.statusListForm.value.repairCategory ? this.statusListForm.value.repairCategory : null,
        };
        let finalObj = {}

          finalObj['mappingNumber'] = this.statusListForm.value.mappingNumber
          finalObj['repairNumber'] = this.statusListForm.value.repairNumber
          finalObj['eoEaTi'] = this.statusListForm.value.eoEaTi
          finalObj['description'] = this.statusListForm.value.description
          finalObj['repairClassification'] = this.statusListForm.value.repairClassification
          finalObj['ataChapter'] = this.statusListForm.value.ataChapter
          finalObj['approvedDataSrmReference'] = this.statusListForm.value.approvedDataSrmReference
          finalObj['approvedDataSrmRevisionNumber'] = this.statusListForm.value.approvedDataSrmRevisionNumber
          finalObj['repairDamage'] = this.statusListForm.value.repairDamage
          finalObj['maintenanceTypeId'] = Number(this.statusListForm.value.maintenanceTypeId)
          finalObj['woNrcDfpRef'] = this.statusListForm.value.woNrcDfpRef ? this.statusListForm.value.woNrcDfpRef : null
          finalObj['performedDate'] = this.statusListForm.value.performedDate ? format( new Date(this.statusListForm.value.performedDate), "yyyy-MM-dd") : null,
          finalObj['performedTac'] = this.statusListForm.value.performedTac ? this.statusListForm.value.performedTac : null
          finalObj['performedTat'] = this.statusListForm.value.performedTat ? this.statusListForm.value.performedTat : null
          finalObj['initialComplianceRemarks'] = this.statusListForm.value.initialComplianceRemarks ? this.statusListForm.value.initialComplianceRemarks : null
          finalObj['maintenanceTypeId'] = Number(this.statusListForm.value.maintenanceTypeId)



        // if create for status list
      if (this.data === null){

        finalObj['assetMaintenance']=obj
        let data ={
          recordObj: finalObj,
        };

          this.statusListSub = this.apiService.addRepairDemage(data).subscribe((res: any) => {
            if(res !== null){
                this.apiService.openSnackBar("Data Created Successfully");
                this.statusListForm.reset()
                this.apiService.maintenanceTaskAddEditModelHeightChangeUsingRepairCategory.next(false);
                this.modalController.dismiss({
                  'dismissed': true
                });
                this.isSaving = false;
            }
          },(err:any)=>{
            this.isSaving = false;
            this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)

          }),(err:any)=>{
            this.isSaving = false;
            this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
          };

      }
      // update for status list
      else{
        obj['id'] = Number(this.data?.assetMaintenanceMappingId)
        finalObj['assetMaintenance']=obj
        finalObj['id']= this.data?.id

        let data ={
          recordObj: finalObj,
        };

          this.statusListSub = this.apiService.updateRepairDemage(data).subscribe((res: any) => {
            if(res !== null){
              this.apiService.openSnackBar("Data Updated Successfully");
                this.statusListForm.reset()
                this.apiService.maintenanceTaskAddEditModelHeightChangeUsingRepairCategory.next(false);
                this.modalController.dismiss({
                  'dismissed': true
                });
              }

              this.isSaving = false;
          },(err:any)=>{
            this.isSaving = false;
             this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)

          }),(err:any)=>{
            this.isSaving = false;
             this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
          };

      }
      } catch(err){
         this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
      }

    }

    // public getRepairDemageData(): void {
    //   try {
    //    this.taskIdList = [];
    //    const params = {
    //     page:1,
    //     limit:1000
    //   };
    //    this.awdbSub = this.apiService.getRepairDemage(params).subscribe((res: any) => {
    //        if (res?.data?.length !== undefined) {
    //         console.log(this.data)
    //          this.taskIdList = res.data;
    //          this.filteredItems = res.data;
    //          this.statusListForm.patchValue({ statusListId: this.data?.statusListId }); // or whatever initial value

    //        }
    //      });
    //      } catch (err) {
    //        this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
    //      }
    //  }

    disableEnableFieldUsingRepairCategory(event:any){
     if(event.value.toLowerCase() === 'permanent'){
      this.clearValidationOnForm()
      this.formDisableEnableUsingRepairDamageValue = true
      this.statusListForm.get('occurrenceAlertThreshold').disable({ emitEvent: false })
      this.statusListForm.get('occurrenceAlertRepeatInterval').disable({ emitEvent: false })
      this.statusListForm.get('additionalRequirement').disable({ emitEvent: false })
      this.statusListForm.get('thresholdTat').setValue('')
      this.statusListForm.get('thresholdTac').setValue('')
      this.statusListForm.get('repeatIntervalDays').setValue('')
      this.statusListForm.get('repeatIntervalFh').setValue('')
      this.statusListForm.get('repeatIntervalFc').setValue('')
      this.statusListForm.get('thresholdDate').setValue('')
      this.statusListForm.get('additionalRequirement').setValue('')
      this.statusListForm.get('occurrenceAlertRepeatInterval').setValue('')
      this.statusListForm.get('occurrenceAlertThreshold').setValue('')
     }
     else{
      this.formDisableEnableUsingRepairDamageValue = false
      this.statusListForm.get('additionalRequirement').enable({ emitEvent: false })
      this.statusListForm.get('occurrenceAlertRepeatInterval').enable({ emitEvent: false })
      this.statusListForm.get('occurrenceAlertThreshold').enable({ emitEvent: false })
      this.applyRequiredFormCheck(false)
      this.statusListForm.markAsUntouched()
     }
    }


    valueCheck(){
      const repairNumberValue = this.statusListForm.get('repairNumber')?.value ? String(this.statusListForm.get('repairNumber')?.value).trim() : null;
      const mappingNumberValue = this.statusListForm.get('mappingNumber')?.value ? String(this.statusListForm.get('mappingNumber')?.value).trim() : null;
      if (repairNumberValue || mappingNumberValue) {
        this.statusListForm.get('repairNumber')?.clearValidators();
        this.statusListForm.get('repairNumber')?.setErrors(null);

        this.statusListForm.get('mappingNumber')?.clearValidators();
        this.statusListForm.get('mappingNumber')?.setErrors(null);
      }

      // Apply changes
      this.statusListForm.get('repairNumber')?.updateValueAndValidity();
      this.statusListForm.get('mappingNumber')?.updateValueAndValidity();

      this.cdr.detectChanges();
    }

public ngOnDestroy(): void {

    if (this.awdbSub !== null && this.awdbSub !== undefined) {
      this.awdbSub.unsubscribe();
    }
    if (this.statusListSub !== null && this.statusListSub !== undefined) {
      this.statusListSub.unsubscribe();
    }

  }


}
